import { Link } from 'react-router-dom';
import '../../styles/system.css';

export default function UnauthorizedAccess() {
  const whatsappText = encodeURIComponent(
    'Hello MF_NAILEDIT, I need help with access to the studio administration area.'
  );

  return (
    <main className="system-page">
      <section className="system-card system-card-error" aria-labelledby="unauthorized-title">
        <span className="system-pill system-pill-error">ACTION REQUIRED</span>
        <h1 id="unauthorized-title">Access denied</h1>
        <p className="system-copy">
          This account does not have permission to view studio administration or customer records.
        </p>

        <div className="system-note">
          <span>DEVELOPER RULE</span>
          <p>
            Show this state instead of a broken screen. Preserve clear recovery actions and never expose private booking,
            payment or customer data while unauthorised.
          </p>
        </div>

        <Link className="button button-primary system-action" to="/admin/login">
          Return to login
        </Link>
        <a
          className="button button-secondary system-action"
          href={`https://wa.me/2347069460987?text=${whatsappText}`}
          target="_blank"
          rel="noreferrer"
        >
          Contact owner
        </a>
      </section>
    </main>
  );
}
